import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Layout } from 'antd';
import type React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useCheckMobileScreen from '@/app/hooks/useCheckMobileScreen';
import { MOBILE_BREAKPOINT } from '@/const/system';
import { Logo, Menu, MenuMobile } from './components';
import styles from './Sidebar.module.css';

interface SidebarProps {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed = false, setCollapsed = () => {} }) => {
  const isMobile = useCheckMobileScreen(MOBILE_BREAKPOINT);
  const customise = useSelector((state: any) => state.customise);

  useEffect(() => {
    setCollapsed(customise.sidebarCollapsed);
  }, [customise, setCollapsed]);

  // Mobile Sidebar
  const closeSidebarHandler = () => {
    setCollapsed(false);
  };

  const toggle = () => {
    setCollapsed((v) => !v);
  };

  return isMobile ? (
    <MenuMobile onClose={closeSidebarHandler} visible={collapsed} />
  ) : (
    <Layout.Sider className={styles.wrapper} theme={customise.theme} collapsed={collapsed} width={280}>
      {customise.sidebarCollapseButton && (
        <Button
          shape="circle"
          size="small"
          icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
          className={styles.sidebarCollapseButton}
          onClick={toggle}
        />
      )}
      <Logo closeHandler={closeSidebarHandler} small={collapsed} />
      <Menu onClose={closeSidebarHandler} />
    </Layout.Sider>
  );
};

export default Sidebar;
